module.exports = __webpack_public_path__ + "static/media/67.a5a6a4ab.jpg";